export default __webpack_public_path__ + "static/media/penyFailure@2x.a593f3a2.png";